import { render, staticRenderFns } from "./ElectronicTemplateManage.vue?vue&type=template&id=5d6b73c5&"
import script from "./ElectronicTemplateManage.vue?vue&type=script&lang=js&"
export * from "./ElectronicTemplateManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports